import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { setExtendSubscriptionFormAction } from "../../redux/rootReducer";
import CalendarOffline from "../../components/CalendarOffline/CalendarOffline";
import { ExtendSubscriptionThunk } from "../../redux/thunks/ExtendSubscriptionThunk";

const ExtendSubscriptionForm = () => {
    const dispatch = useDispatch();
    const extend_subscription_form = useSelector(state => state.extend_subscription_form);

    const [openCalendar, setOpenCalendar] = useState(false);

    if (!extend_subscription_form.open) return false;

    return (
        <div className="form form--extend-subscription">
            <div className="form__scrollable" style={{ paddingBottom: '180px' }}>
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(setExtendSubscriptionFormAction({
                            ...extend_subscription_form,
                            open: false
                        })) }/>
                        <div className="form__title">{ `Абонемент № ${ extend_subscription_form.subscription_id }` }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Новый срок действия</div>
                        <div className="input input--datepicker"
                             onClick={ (event) => {
                                 event.preventDefault();
                                 event.stopPropagation();
                                 setOpenCalendar(!openCalendar);
                             } }
                        >{ extend_subscription_form.expire_date ? new Date(extend_subscription_form.expire_date).toLocaleDateString('ru-Ru') : '' }</div>
                        <CalendarOffline
                            date={ extend_subscription_form.expire_date }
                            handler={ date => {
                                setOpenCalendar(false);
                                dispatch(setExtendSubscriptionFormAction({
                                    ...extend_subscription_form,
                                    expire_date: date
                                }));
                            } }
                            open={ openCalendar }
                            close={ () => setOpenCalendar(false) }
                            style={{ margin: '8px auto 0 auto', left: 0, right: 0 }}
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(ExtendSubscriptionThunk({
                                subscription_id: extend_subscription_form.subscription_id,
                                expire_date: extend_subscription_form.expire_date
                            })) }
                        >Продлить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExtendSubscriptionForm;